<template>
	<div class="topbar__partner-area">
		<button
			@click.prevent="toggleCodeForm"
			role="button"
			class="button topbar__button"
			:class="{'button--outlined': this.$store.state.app.isPartnerFormVisible}"
		>
			Strefa partnera
		</button>

		<div class="topbar__antishadow" v-if="this.$store.state.app.isPartnerFormVisible">
			<div class="topbar__code-form">
				<span @click.prevent="toggleCodeForm" class="topbar__close"></span>
				<p class="topbar__header">Wprowadź swój kod:</p>
				<form @submit.prevent="submit">
					<input type="text" class="topbar__input" v-model="secretCode" />
					<span v-if="error" class="topbar__error">{{ error }}</span>
					<button
						@click.prevent="submit"
						class="button topbar__submit"
						role="submit"
						:disabled="!isSubmitEnabled"
					>
						Zatwierdź
					</button>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import {api} from '@/core/services/api';

export default {
	name: 'PartnerArea',
	data() {
		return {
			secretCode: '',
			error: '',
			isPending: false,
			lastSecretCodeThatFailed: null,
		};
	},
	computed: {
		isSubmitEnabled() {
			return (
				this.secretCode.length > 4 &&
				this.secretCode !== this.lastSecretCodeThatFailed &&
				!this.isPending
			);
		},
	},
	methods: {
		toggleCodeForm() {
			const newState = !this.$store.state.app.isPartnerFormVisible;
			if (newState && this.$store.state.user) {
				this.$router.replace({name: 'partner'});
			}

			this.$store.commit('M_SET_APP_STATE', {
				isPartnerFormVisible: newState,
			});
		},
		async submit() {
			this.error = '';
			this.isPending = true;
			try {
				const user = (await api.post('/users/partnerLogin', {secretCode: this.secretCode})).data;
				this.toggleCodeForm();
				this.$store.commit('setUser', user);
			} catch (e) {
				this.lastSecretCodeThatFailed = this.secretCode;
				this.error = 'Niepoprawny kod.';
			} finally {
				this.isPending = false;
			}
		},
	},
};
</script>
